module.exports = __webpack_public_path__ + "assets/img/00122.f3c7bd6a.png";